import HTTP from '@/plugins/http';

const withdrawApi = {
  amount: '/merchant/wallet/amount',
  byNo: '/merchant/byNo',
  withdraw: '/merchant/withdraw',
  bank: '/withdrawBank/getByMerchatNo',
  auth: '/merchant/captcha/auth',
  summary: '/merchant/wallet/amountSummary',
  transfer: '/merchant/balance/transfer'
};

function doTransfer(data) {
  return HTTP({
    url: withdrawApi.transfer,
    method: 'post',
    data
  });
}

export function getAmount(params) {
  return HTTP.loading({
    url: withdrawApi.amount,
    method: 'get',
    params
  });
}
export function getSummary(params) {
  return HTTP({
    url: withdrawApi.summary,
    method: 'get',
    params
  });
}
export function getBank(params) {
  return HTTP({
    url: withdrawApi.bank,
    method: 'get',
    params
  });
}
export function getAuth(params) {
  return HTTP.loading({
    url: withdrawApi.auth,
    method: 'get',
    params
  });
}

export function doWithdraw(data) {
  return HTTP.loading({
    url: withdrawApi.withdraw,
    method: 'post',
    data
  });
}
export function getmerchantNo(data) {
  return HTTP({
    url: withdrawApi.byNo,
    method: 'post',
    data
  });
}
export default {
  getAmount,
  getBank,
  getAuth,
  doWithdraw,
  getmerchantNo,
  getSummary,
  doTransfer
};



// WEBPACK FOOTER //
// ./src/api/merchantdeposit.js